export default "__VITE_ASSET__DmwWTTfb__"